import { LifeDomainId } from '@erikdakoda/database/enums';
import { registerVocabularyValues } from '@erikdakoda/database/shared/vocabularyRegistry';
import { UVILO_FACTOID_CATEGORY_VALUES } from './uviloFactoidCategoryValues';

const UVILO_APP = 'uvilo-ai';

let seeded = false;

/**
 * Seeds uvilo-ai factoid category and life-domain vocabularies from enum/value arrays.
 * Call from every app's `init` (uvilo-ai and forgentic): reads/display bleed through;
 * write-time validation stays scoped to the row's own app slot map.
 * Idempotent; safe to call from app `initPackages`.
 */
export function seedUviloVocabulary(): void {
  if (seeded) return;
  seeded = true;

  // Loop over value arrays — never list individual registerVocabularyEntry calls with literals.
  registerVocabularyValues(UVILO_APP, 'factoid-category', UVILO_FACTOID_CATEGORY_VALUES);
  registerVocabularyValues(UVILO_APP, 'life-domain', Object.values(LifeDomainId));
}
